import { BaseQuestionnaireRoute } from '../slice';

export type SoleProprietorshipForm1099MISCand1099NECRoutes = BaseQuestionnaireRoute;

export const soleProprietorshipForm1099MISCand1099NECRoutes: { soleProprietorshipForm1099MISCand1099NEC: SoleProprietorshipForm1099MISCand1099NECRoutes } = {
    soleProprietorshipForm1099MISCand1099NEC: {
    title: 'Sole Proprietorship Form 1099MISC and 1099NEC',
    path: 'soleProprietorshipForm1099MISCand1099NEC',
    isValid: undefined,
  },
};
